export enum LinkedinLoginTypeEnum {
  None = 0,
  Dev = 1,
  Intelliplan = 2,
  Custom = 3
}
